import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'catalog-v2',
});

export const systemDetailsRouteRef = createSubRouteRef({
  id: 'catalog-v2:system-details',
  parent: rootRouteRef,
  path: '/:namespace/:kind/:name',
});
